import { date02format } from '@razlet/sdk/lib/utils/date';

function fillDate(date) {
  const dateStringInTz = date.toLocaleString('en-EN', { 
    timeZone: 'Europe/Moscow',
  });
  const dateInTz = new Date(dateStringInTz);
  return `${dateInTz.getFullYear()}-${date02format(dateInTz.getMonth()+1)}-${date02format(dateInTz.getDate())}`;
}

export default class {
  constructor() {
    const today = new Date();
    this.today = fillDate(today);

    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    this.yesterday = fillDate(yesterday);

    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    this.tomorrow = fillDate(tomorrow);

    this.date = 'today';

    this.direction = 'arrival';
    this.term = '';
  }

  setDateByDay (day = 'today') {
    this.date = this[day];
  }

  setDirection (direction) {
    this.direction = direction;
  }

  buildRequest(city) {
    const params = {
      city,
      date: this.date,
      direction: this.direction,
      term: this.term,
    };

    return params;
  }

  /* buildRequest() {
    return {
      city: 'MSQ',
      direction: this.direction,
      date: '2026-02-12',
    };
  } */
}